<!-- Header -->
<div class="card-header pt-0 card-header-grid">
  <!-- Search -->
  <div class="input-group input-lined" role="search">
    <div class="input-group-text">
      <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
    </div>
    <input
      [(ngModel)]="filterTerm"
      class="form-control"
      placeholder="{{ 'general.search' | translate }}"
      attr.aria-label="{{ 'general.search' | translate }}"
      style="width: 30%"
      type="search"
    />
  </div>
  <!-- End Search -->

  <div class="d-flex justify-content-end align-items-center">
    <div>
      <span>
        {{
          (
            tableData
            | saleItemsGroupByProduct
            | async
            | recursiveFilter : filterTerm
          )?.length
        }}
        {{ 'general.total' | translate }}
      </span>
    </div>

    <div
      *ngIf="bulkActions?.length && saleItemsAreAdjustable"
      class="btn-group ms-3"
      dropdown
    >
      <button
        class="btn btn-sm btn-white dropdown-toggle"
        dropdownToggle
        type="button"
        aria-controls="bulkAction3"
      >
        {{ 'general.bulkActions' | translate }}
      </button>

      <ul
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        id="bulkAction3"
      >
        <li *ngFor="let bulkAction of bulkActions">
          <a
            href="javascript:;"
            (click)="onClickBulkAction(bulkAction)"
            class="dropdown-item"
          >
            {{ 'general.' + bulkAction | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- End Row -->
</div>
<!-- End Header -->
<!-- LIST -->

<div
  class="spinner-border"
  role="status"
  attr.aria-label="{{ 'general.loading' | translate }}"
  *ngIf="isLoading$ | async"
>
</div>

<div class="table-responsive">
  <table
    [hidden]="isLoading$ | async"
    *ngIf="productEntities$ | async as productEntities"
    class="table table-striped"
    #dataTable="mfDataTable"
    [mfData]="
      tableData | saleItemsGroupByProduct | async | recursiveFilter : filterTerm
    "
    [mfRowsOnPage]="5"
  >
    <div
      class="row gx-2 px-2 bg-light border-bottom py-3 border-top text-uppercase text-primary"
    >
      <div class="col-1">
        <input
          (click)="onToggleAllChecked()"
          [checked]="allCheckedToggle"
          type="checkbox"
          class="form-check-input"
          *ngIf="bulkActions?.length && saleItemsAreAdjustable"
        />
      </div>
      <div class="col-3">
        <mfDefaultSorter by="saleLine">
          {{ 'general.activity' | translate }}
        </mfDefaultSorter>
      </div>

      <div class="col">{{ 'general.category' | translate }}</div>
      <div class="col">{{ 'tagModule.tags' | translate }}</div>

      <div class="col">
        <mfDefaultSorter by="quantity">
          {{ 'participationModule.participation' | translate }}
        </mfDefaultSorter>
      </div>
      <div class="col">
        <mfDefaultSorter by="quantity">
          {{ 'shopModule.quantity' | translate }}
        </mfDefaultSorter>
      </div>
      <div class="col">
        <mfDefaultSorter by="total">
          {{ 'general.total' | translate }}
        </mfDefaultSorter>
      </div>
      <div class="col" [hidden]="!saleItemsAreAdjustable">
        {{ 'general.edit' | translate }}
      </div>
    </div>
    <ng-container *ngFor="let groupItem of dataTable.data; let i = index">
      <div *ngIf="groupItem.productId" class="h4 mb-0">
        <a
          href="javascript:;"
          (click)="onCollapseRow(groupItem.productId)"
          class="w-100"
        >
          <i
            class="me-1 fa fa-fw"
            [ngClass]="
              collapsedRows.get(groupItem.productId)
                ? 'fa-chevron-right'
                : 'fa-chevron-down'
            "
            role="img"
            attr.aria-label="{{ 'general.toggle' | translate }}"
          ></i>

          <span class="px-2 py-3 d-inline-block">
            {{ productEntities[groupItem.productId]?.description }}</span
          >
        </a>
      </div>
      <ng-container *ngIf="!collapsedRows.get(groupItem.productId)">
        <div
          class="row gx-2 px-2 py-3 border-bottom"
          *ngFor="let item of groupItem.saleItems"
        >
          <span hide>{{ setPrintProduct(item.id) }}</span>
          <div class="col-1">
            <div
              (click)="onCheckRow(item)"
              *ngIf="bulkActions?.length && saleItemsAreAdjustable"
            >
              <input
                [checked]="this.checkedIds.get(item.id)"
                type="checkbox"
                class="form-check-input"
              />
            </div>
          </div>

          <div class="col-3">
            <div class="name-text h5" *ngIf="item.productId">
              {{ productEntities[item.productId]?.description }}
            </div>

            <div class="h5" *ngIf="item.subscriptionId">
              {{
                (subscriptionEntities$ | async)[item.subscriptionId]
                  ? (subscriptionEntities$ | async)[item.subscriptionId]
                      ?.description
                  : 'subscriptionId'
              }}
            </div>
            <div class="h5" *ngIf="item.courseId">
              {{
                (courseEntities$ | async)[item.courseId]
                  ? (courseEntities$ | async)[item.courseId]?.description
                  : 'courseId'
              }}
            </div>
            <div *ngIf="(getParticipationsProducts(item) | async).length > 0">
              <div class="fs-sm">
                <span
                  class="fw-bold"
                  *ngFor="
                    let participationsProduct of getParticipationsProductsByDate(
                      item.productId
                    )
                  "
                >
                  <span *ngIf="productPrinted(item)">
                    <ng-container
                      *ngFor="let item of convertToArray(participationsByDate)"
                    >
                      <div class="data-text">
                        {{ 'productModule.resource' | translate }}:
                        {{ getDescription(item) }}
                      </div>
                      <div class="data-text">
                        {{ 'general.startDate' | translate }}:
                        {{
                          getCorrectFormatDate(item[0])
                            | date : 'dd-MM-yyyy HH:mm'
                        }}
                      </div>
                      <div class="data-text">
                        {{ 'general.endDate' | translate }}:
                        {{
                          getCorrectFormatDate(item[1].endDate)
                            | date : 'dd-MM-yyyy HH:mm'
                        }}
                      </div>
                    </ng-container>
                  </span>
                </span>
              </div>
            </div>
            <div
              *ngIf="
                (getParticipationsProducts(item) | async)?.length === 0 &&
                item?.params?.bookableProductId
              "
            >
              <div class="fs-sm">
                {{ 'productModule.resource' | translate }}:
                <span class="fw-bold">
                  {{
                    productEntities[item.params.bookableProductId]?.description
                  }}
                </span>
              </div>
            </div>

            <ng-container
              *ngIf="bookingItemEntities$ | async as bookingItemEntities"
            >
              <div
                *ngIf="item?.bookingItems && item?.bookingItems?.length > 0"
                class="fs-sm"
              >
                {{ 'bookingModule.booking' | translate }}
                {{ 'productModule.resource' | translate }}:
                <span
                  *ngFor="
                    let bookingItemId of item.bookingItems;
                    let last = last
                  "
                >
                  <span class="fw-bold">
                    {{
                      productEntities[
                        bookingItemEntities[bookingItemId]?.productId
                      ]?.description
                    }}
                  </span>
                  <span *ngIf="!last">,</span>
                </span>
              </div>
            </ng-container>

            <div
              class="fs-sm"
              *ngIf="
                item.description &&
                (getParticipationsProducts(item) | async)?.length === 0
              "
            >
              {{ item.description }}
            </div>

            <div class="fs-sm">
              <span *ngIf="item.bookingItems?.length > 0" class="fw-bold">
                {{
                  (bookingItemEntities$ | async)[item.bookingItems[0]]
                    ?.startDate
                    | date : 'd MMMM yyyy' : null : (selectedLanguage$ | async)
                }}

                {{
                  (bookingItemEntities$ | async)[item.bookingItems[0]]
                    ?.startDate
                    | date : 'HH:mm' : null : (selectedLanguage$ | async)
                }}
                -
                {{
                  (bookingItemEntities$ | async)[item.bookingItems[0]]?.endDate
                    | date : 'HH:mm' : null : (selectedLanguage$ | async)
                }}
              </span>
            </div>
          </div>

          <!--    'general.category'-->
          <div class="col align-self-center">
            <span
              *ngIf="
                item.customerCategory &&
                (
                  item.customerCategory
                  | customerCategoryName : item?.siteId
                  | async
                ).trim().length > 0
              "
              class="badge bg-soft-secondary"
            >
              {{
                item.customerCategory
                  | customerCategoryName : item?.siteId
                  | async
              }}
            </span>
            <span
              *ngIf="
                !item.customerCategory ||
                (item.customerCategory &&
                  (
                    item.customerCategory
                    | customerCategoryName : item?.siteId
                    | async
                  ).trim().length == 0)
              "
              class="badge bg-soft-warning"
            >
              {{ 'general.noCategory' | translate }}
            </span>
          </div>

          <!--    'tagModule.tags'-->
          <div class="col align-self-center">
            <span
              *ngFor="let tag of getTags$(item) | async"
              class="badge bg-soft-secondary"
            >
              <span *ngIf="tag">
                {{ tag['description_' + (selectedLanguage$ | async)] }}
              </span>
            </span>
          </div>

          <!--    'participationModule.participation'-->
          <div class="col align-self-center">
            <span *ngIf="item.saleId">{{
              (getItemParticipants$(item) | async)?.length
            }}</span>
            <span *ngIf="!item.saleId">{{ getParticipants(item) }}</span>
          </div>
          <!--    'shopModule.quantity'-->
          <div class="col align-self-center">
            <span>{{ item?.quantity }}</span>
          </div>
          <!--    'general.total'-->
          <div class="col align-self-center">
            <!--          {{-->
            <!--            saleItemService.getTotal(-->
            <!--              item,-->
            <!--              productEntities[item.productId],-->
            <!--              selectedCustomer$ | async,-->
            <!--              subscribers-->
            <!--            ) | currency-->
            <!--          }}-->

            {{ (item | getSaleItemProductPrice | async)?.total | currency }}
          </div>

          <!--    'general.edit'-->
          <div class="col align-self-center" [hidden]="!saleItemsAreAdjustable">
            <button
              type="button"
              (click)="onRowClicked(item)"
              class="btn btn-sm btn-ghost-primary"
            >
              <i
                role="img"
                class="fa fa-pen"
                attr.aria-label="{{ 'general.edit' | translate }}"
              ></i>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="justify-content-between mt-5">
      <mfBootstrapPaginator [rowsOnPageSet]="[50, 100]"></mfBootstrapPaginator>
    </div>
  </table>
</div>
<!-- END list-->
